import React from 'react';
import { Collapse, Skeleton, Col } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';
import { TableCard, SummaryGrid, StyledStatistic, DividerStyled, TableTitle, HelpText } from './Styles';

const { Panel } = Collapse;

interface SupportTicketsSectionProps {
  isOpen: boolean;
}

const SupportTicketsSection: React.FC<SupportTicketsSectionProps> = ({ isOpen }) => {
  const { loading } = useSelector((state: RootState) => state.adminReports);

  return (
    <Collapse activeKey={isOpen ? ['support'] : []} ghost>
      <Panel key="support" header="" showArrow={false}>
        {loading ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          <TableCard>
            <TableTitle level={4}>
              Support Tickets Overview
            </TableTitle>
            <SummaryGrid>
              <Col xs={24} sm={8}>
                <StyledStatistic
                  title="Open Tickets"
                  value={3}
                  valueStyle={{ color: '#f59e0b' }}
                />
                <HelpText>Requires attention</HelpText>
              </Col>
              <Col xs={24} sm={8}>
                <StyledStatistic
                  title="In Progress"
                  value={2}
                  valueStyle={{ color: '#3b82f6' }}
                />
                <HelpText>Being resolved</HelpText>
              </Col>
              <Col xs={24} sm={8}>
                <StyledStatistic
                  title="Resolved"
                  value={15}
                  valueStyle={{ color: '#10b981' }}
                />
                <HelpText>This month</HelpText>
              </Col>
            </SummaryGrid>
            <DividerStyled />
            <HelpText>
              For detailed support ticket management, please visit the Support page.
            </HelpText>
          </TableCard>
        )}
      </Panel>
    </Collapse>
  );
};

export default SupportTicketsSection;
